// extracted by mini-css-extract-plugin
export default {"tabContainer":"tabsLinks_tabContainer__Y8i7A","tabActive":"tabsLinks_tabActive__aAfyK"};